// import Vue from "vue";

const state = {
   tutorials: [],
};
const mutations = {
   setTutorials(state, data) {
      state.tutorials = data;
   },
};
export const ui = {
   namespaced: true,
   state,
   mutations,
};
